import AppComponent from '../../mixins/app-component'

import AppIcon from '../app-icon'

export default
{
    name: 'app-token-prac-earned',

    mixins: [
        AppComponent
    ],

    components: {
        AppIcon
    },

    props: {
        label: { type: String, default: 'earned' },
        prax: { type: Number, default: 0 },
        easing: { type: Number, default: 0.1 }
    },

    data() {
        return {
            praxString: '0.000'
        }
    },

    created() {
        this.praxValue = this.prax
        
        this.eventHub.$on('application:onEnterFrame', this.onEnterFrame)
    },

    destroyed() {
        this.eventHub.$off('application:onEnterFrame', this.onEnterFrame)
    },
    
    methods: {
        onEnterFrame() {
            this.praxValue += (this.prax - this.praxValue) * this.easing
            this.praxString = this.praxValue.toFixed(3)
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-token-prac-earned/script.js